module.exports = {
  address: "0x4a892411115314f78e06930664c42a6b326ac675",
  address_test: '0x72ACFb50D1eA0A0ef941a3C82378B594714abf0f',
  abi: require('./ClaimIdo.abi.json')
}
